/**
 * Чистая часть вкладки «Уровни»: какие шаблоны можно выбрать и что делает
 * щелчок по шаблону. Вынесено из разметки ради тестов (`levels.test.ts`) —
 * это единственное место вкладки, где есть решение, а не отрисовка.
 *
 * Состояний ролика («готов», «в очереди», кнопки заказа и пересъёмки)
 * здесь БОЛЬШЕ НЕТ. Они имели смысл, пока цель настройки была одной
 * героиней: у неё один ролик на клип, и про него можно было сказать
 * «готов». Цель стала характером, а ролик по-прежнему живёт парой
 * (ассистентка, клип) — их у одного клипа столько, сколько игроков дошло
 * до уровня. Очередь проверки снятого — отдельный экран со своим запросом,
 * а не колонка в настройке шаблонов.
 */

export interface TemplateOption {
  id: string
  name: string
}

/**
 * Список шаблонов, доступных для набора уровня.
 *
 *  - Шаблоны с `needPrompt` исключены: поля под текстовый промпт в
 *    контенте нет, выбрать их всё равно нельзя (см. `Templates.tsx`, где
 *    они, наоборот, показаны серым, а не спрятаны).
 *  - Уже выбранный шаблон, которого нет в каталоге (партнёр выключен,
 *    шаблон сняли с продажи, или в базе старыми путями оказался
 *    needPrompt-шаблон), дописан ПЕРВЫМ с пометкой «нет в каталоге» —
 *    иначе панель молча выбросила бы его из набора владельца, и первое
 *    же сохранение удалило бы ролик, за который заплачено.
 */
export function catalogOptions(
  templates: { id: string; name: string; needPrompt: boolean }[],
  selected: readonly string[],
): TemplateOption[] {
  const selectable = templates.filter((t) => !t.needPrompt)
  const known = new Set(selectable.map((t) => t.id))
  const missing = selected.filter((id) => id !== '' && !known.has(id))
  return [...missing.map((id) => ({ id, name: `${id} (нет в каталоге)` })), ...selectable]
}

/**
 * Щелчок по шаблону в панели: добавить в конец или убрать.
 *
 * Второй раз тот же шаблон в набор не попадает — не «схлопывается молча»,
 * а именно не добавляется: два клипа одного шаблона это два похожих ролика
 * за две цены, и сервер такой набор всё равно отвергает (422).
 */
export function toggleTemplate(selected: readonly string[], id: string): string[] {
  return selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]
}
